import { alphabeticalSort } from '@cims-online/shared'
import { Cell, Header } from './types'

export class GoogleSheetRecord {
  private sorted: Header[]
  private m = new Map<string, Cell & { header: Header }>()
  constructor(headers: Header[] = [], row: Cell[] = []) {
    row.forEach((cell) => {
      const lines = cell.formattedValue?.split('\n') ?? []
      this.maxCellWidth = Math.max(
        lines.reduce((max, line) => Math.max(max, line.length), 0),
        this.maxCellWidth
      )
      const header = headers.find(({ id }) => cell.headerId === id)
      if (header) this.m.set(header.id, { ...cell, header })
    })
    this.sorted = headers.sort(alphabeticalSort('order'))
    this.rowKey = row.map(({ id }) => id).toString()
    this.someInvisible = headers.some(({ visible }) => !visible)
  }
  /**
   * after splitting the cell's formatted value on '\n', get the max length
   */
  maxCellWidth = 0
  /**
   * each cell id joined with a comma
   */
  rowKey: string
  /**
   * whether some of the headers are marked as !visible
   */
  someInvisible = false
  /**
   * a mapping function to execute for each cell, sorted by the header order
   */
  map<T>(
    fn: (cell: Cell & { header: Header }, i: number, array: Header[]) => T
  ) {
    return this.sorted.map((header, i, a) =>
      fn(this.getCellOrFail(header), i, a)
    )
  }
  getCell({ id }: Header) {
    return this.m.get(id)
  }
  getCellOrFail(header: Header) {
    const got = this.getCell(header)
    if (!got)
      throw new Error(`Failed to get cell for header: ${header.formattedValue}`)
    return got
  }
}
